import React from 'react';
import { XIcon } from 'lucide-react';
import { situations, situationsClosing, situationsIntro, situationsTitle } from '../data/content';
export function Situations() {
  return <section className="w-full bg-white py-14 md:py-20" data-id="element-240" data-mp="rxue7acpdl8u">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-241" data-mp="rw9iviikdy9x">
        <header className="mx-auto max-w-3xl text-center" data-id="element-242" data-mp="vzo9t481jz25">
          <h2 className="text-3xl font-extrabold leading-tight tracking-tight text-slate-900 md:text-5xl" data-id="element-243" data-mp="vx34u6cg5306">
            {situationsTitle}
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-lg text-blue-900/70" data-id="element-244" data-mp="15wk9ckfypauk">{situationsIntro}</p>
        </header>

        <ul className="mx-auto mt-10 grid max-w-4xl gap-4 md:grid-cols-2 md:gap-5" data-id="element-245" data-mp="1apn3atonimba">
          {situations.map(item => <li key={item.title} className="flex h-full items-start gap-4 rounded-2xl bg-red-50 px-5 py-5 ring-1 ring-red-100" data-id="element-246" data-mp="1fphu6x8ffbwc">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-red-100 text-red-600" data-id="element-247" data-mp="1oov8c37hwone">
                <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-248" data-mp="3lftkrm7owk8w" />
              </span>
              <div className="min-w-0" data-id="element-249" data-mp="3hf1b4ruwodc3">
                <h3 className="font-extrabold leading-snug tracking-tight text-slate-900" data-id="element-250" data-mp="3cgzs26xhce0m">
                  {item.title}
                </h3>
                <p className="mt-1.5 leading-relaxed text-blue-900/75" data-id="element-251" data-mp="37jgdf5wvdz85">{item.text}</p>
              </div>
            </li>)}
        </ul>

        <p className="mx-auto mt-10 max-w-3xl text-center text-2xl font-extrabold italic leading-snug tracking-tight text-blue-600 md:text-3xl" data-id="element-252" data-mp="41g33k3udhrd">
          {situationsClosing}
        </p>
      </div>
    </section>;
}